// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileSubNavigation_container__DKalP","link":"MobileSubNavigation_link__Bs4c6"};